module.exports = __webpack_public_path__ + "022a8bbe50500f2fc0af5025c818e64c.svg";